import React, {Component} from "react";
import './AnalyticsBanner.scss'

class AnalyticsBanner extends Component {
  render() {
    return (
      <div className="analytics-banner">
        ANALYTICS AND STATISTICS
      </div>
    );
  }
}

export default AnalyticsBanner
